import React from 'react';
import ServicePage from '../components/services/ServicePage';
import glassManifestation from '../data/services/glass-manifestation';

const GlassManifestation: React.FC = () => <ServicePage data={glassManifestation} />;

export default GlassManifestation;
